export const EMPTY_NAMES_ERROR = 'Please enter at least one name';
